module.exports = __webpack_public_path__ + "static/media/Questlogoheader.9ce80bc5.png";